// Please keep this list in sync with SharedModels\Models\Currencies.cs (cruises_backend)

const Currencies = {
  '': { name: 'Property Currency', code: '', symbol: '' },
  USD: { name: 'United States Dollar', code: 'USD', symbol: '$' },
  EUR: { name: 'Euro', code: 'EUR', symbol: '€' },
  GBP: { name: 'Pound Sterling', code: 'GBP', symbol: '£' },
  AED: { name: 'United Arab Emirates Dirham', code: 'AED', symbol: 'AED ' },
  AUD: { name: 'Australian Dollar', code: 'AUD', symbol: 'AU$' },
  CAD: { name: 'Canadian Dollar', code: 'CAD', symbol: 'CA$' },
  MXN: { name: 'Mexican Peso', code: 'MXN', symbol: 'MX$' },
};

export default Currencies;
